import { render, staticRenderFns } from "./CourseAssessmentScale.vue?vue&type=template&id=fb111558"
import script from "./CourseAssessmentScale.vue?vue&type=script&lang=ts"
export * from "./CourseAssessmentScale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports